import { useSelector } from "react-redux";
import {
  Navigate,
  useLocation
} from "react-router-dom";

export const Visible = ({ login, roles, children }) => {
    const { user: account } = useSelector((state) => state.auth);
    const loginMatch = login && account.login === login;
    const rolesMatch = roles && roles.some((r) => account.role === r);
    const matched = Boolean(loginMatch || rolesMatch);
    let location = useLocation();
    if (!matched) {
      return <Navigate to="/404" state={{ from: location }} />;
    }

    return children;
  };
